import React, { Fragment } from "react";
import AdminDashboard from "../../components/AdminDashboard";

const AdminDashboardPage = () => {
  return (
    <Fragment>
      <AdminDashboard />
    </Fragment>
  );
};

export default AdminDashboardPage;
